import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("hapo_admin_token") || ""}` },
});

export const fileUrl = (path) =>
  `${API}/files/${path}?auth=${encodeURIComponent(localStorage.getItem("hapo_admin_token") || "")}`;

export const mediaUrl = (src) =>
  src && src.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src;

export const api = {
  sendEnquiry: (data) => axios.post(`${API}/contact`, data),
  subscribe: (email) => axios.post(`${API}/newsletter`, { email }),
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }),
  enquiries: () => axios.get(`${API}/admin/enquiries`, auth()),
  deleteEnquiry: (id) => axios.delete(`${API}/admin/enquiries/${id}`, auth()),
  subscribers: () => axios.get(`${API}/admin/newsletter`, auth()),
  uploadCv: (formData) => axios.post(`${API}/careers/cv`, formData),
  listCvs: () => axios.get(`${API}/admin/cvs`, auth()),
  insights: () => axios.get(`${API}/insights`),
  insight: (id) => axios.get(`${API}/insights/${id}`),
  createPost: (data) => axios.post(`${API}/admin/posts`, data, auth()),
  deletePost: (id) => axios.delete(`${API}/admin/posts/${id}`, auth()),
  uploadInsightImage: (formData) => axios.post(`${API}/admin/insights/image`, formData, auth()),
  vacancies: () => axios.get(`${API}/vacancies`),
  createVacancy: (data) => axios.post(`${API}/admin/vacancies`, data, auth()),
  deleteVacancy: (id) => axios.delete(`${API}/admin/vacancies/${id}`, auth()),
};
